module.exports = __webpack_public_path__ + "img/2019110805.80d345c5.jpg";